// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_Nlv","cls2":"ClaimDetails-cls2__D8 ClaimDetails-cls1_Nlv"};